// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_fC","advertDetailHeaderPrice__value":"c-m_fE","advertDetailHeaderPrice__label":"c-m_fF"};